import axios from "axios";
export default {
  state: {
    faqs: [],
    selectedFaq: {},
    viewFaq: false,
    faqCategory: [],
    addFaq: false,

    maps: [],
    selectedMap: {},
    viewMap: false,
    floors: [],

    forms: [],
    selectForm: {},
    viewForm: false,
    formCategory: [],
  },
  getters: {
    getFaqs: (state) => state.faqs,
    getSelectedFaq: (state) => state.selectedFaq,
    getViewFaq: (state) => state.viewFaq,
    getFaqCategory: (state) => state.faqCategory,
    getAddFaq: state => state.addFaq,

    getMaps: (state) => state.maps,
    getViewMap: (state) => state.viewMap,
    getSelectedMap: (state) => state.selectedMap,

    getForms: (state) => state.forms,
    getViewForm: (state) => state.viewForm,
    getSelectedForm: (state) => state.selectForm,
    getFormCategory: (state) => state.formCategory,
  },
  mutations: {
    setFaqs(state, faq) {
      state.faqs.push(faq);
    },
    setSelectedFaq(state, faq) {
      state.selectedFaq = faq;
    },
    setViewFaq(state, status) {
      state.viewFaq = status;
    },
    setFaqCategory(state, category) {
      state.faqCategory.push(category);
    },
    setAddFaq(state, status) {
      state.addFaq = status
    },

    setMaps(state, map) {
      state.maps.push(map);
    },
    setViewMap(state, status) {
      state.viewMap = status;
    },
    setSelectedMap(state, map) {
      state.selectedMap = map;
    },

    setForms(state, form) {
      state.forms.push(form);
    },
    setViewForm(state, status) {
      state.viewForm = status;
    },
    setSelectedForm(state, form) {
      state.selectForm = form;
    },
    setFormCategory(state, category) {
      state.formCategory.push(category);
    },
  },
  actions: {
    pullFaqs({ commit, getters }) {
      if (getters.getFaqs.length === 0) {
        let config = {
          method: "get",
          url: "https://cms.elpaso.arsconnect.com/faqs?_limit=-1",
          maxBodyLength: Infinity,
          headers: {
            "Content-Type": "application/json",
          },
        };
        axios
          .request(config)
          .then((response) => {
            response.data.forEach((faq) => {
              console.log("FAQs Fetched: ", faq);
              commit("setFaqs", faq);
            });
          })
          .catch((error) => {
            console.log(error.message);
          });
      }
    },
    pullFaqCategories({ commit, getters }) {
      if (getters.getFaqs.length === 0) {
        let config = {
          method: "get",
          url: "https://cms.elpaso.arsconnect.com/faq-categories?_limit=-1",
          maxBodyLength: Infinity,
          headers: {
            "Content-Type": "application/json",
          },
        };
        axios
          .request(config)
          .then((response) => {
            response.data.forEach((category) => {
              console.log("FAQ Category Fetched: ", category);
              commit("setFaqCategory", category);
            });
          })
          .catch((error) => {
            console.log(error.message);
          });
      }
    },
    pullMaps({ commit, getters }) {
      if (getters.getMaps.length === 0) {
        let config = {
          method: "get",
          url: "https://cms.elpaso.arsconnect.com/maps?_limit=-1",
          maxBodyLength: Infinity,
          headers: {
            "Content-Type": "application/json",
          },
        };
        axios
          .request(config)
          .then((response) => {
            response.data.forEach((map) => {
              console.log("Maps Fetched: ", map);
              commit("setMaps", map);
            });
          })
          .catch((error) => {
            console.log(error.message);
          });
      }
    },
    pullForms({ commit, getters }) {
      if (getters.getForms.length === 0) {
        let config = {
          method: "get",
          url: "https://cms.elpaso.arsconnect.com/forms?_limit=-1",
          maxBodyLength: Infinity,
          headers: {
            "Content-Type": "application/json",
          },
        };
        axios
          .request(config)
          .then((response) => {
            response.data.forEach((form) => {
              console.log("Forms Fetched: ", form);
              commit("setForms", form);
            });
          })
          .catch((error) => {
            console.log(error.message);
          });
      }
    },
    pullFormCategories({ commit, getters }) {
      if (getters.getFaqs.length === 0) {
        let config = {
          method: "get",
          url: "https://cms.elpaso.arsconnect.com/form-categories?_limit=-1",
          maxBodyLength: Infinity,
          headers: {
            "Content-Type": "application/json",
          },
        };
        axios
          .request(config)
          .then((response) => {
            response.data.forEach((category) => {
              console.log("Form Category Fetched: ", category);
              commit("setFormCategory", category);
            });
          })
          .catch((error) => {
            console.log(error.message);
          });
      }
    },
  },
};
